import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgSnapshot = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M15.763 1.808c.361 0 .692.204.854.527l1.326 2.654h2.858a3.341 3.341 0 0 1 3.336 3.158l.005.183v11.137a3.34 3.34 0 0 1-3.341 3.34H4.36a3.34 3.34 0 0 1-3.34-3.34V8.33a3.34 3.34 0 0 1 3.34-3.34l2.857-.001 1.327-2.654a.955.955 0 0 1 .735-.52l.12-.007Zm5.038 5.09H4.36c-.79 0-1.431.642-1.431 1.432v11.137c0 .79.64 1.432 1.431 1.432h16.44c.79 0 1.432-.641 1.432-1.432V8.33c0-.79-.641-1.431-1.432-1.431Zm-8.22 1.804a5.197 5.197 0 1 1 0 10.394 5.197 5.197 0 0 1 0-10.394Zm0 1.909a3.288 3.288 0 1 0 0 6.575 3.288 3.288 0 0 0 0-6.575Zm2.592-6.894H9.988L9.352 4.99h6.458l-.637-1.273Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgSnapshot)
const Memo = memo(ForwardRef)
export default Memo
